export type SubmitterUser = {
  id?: string | null;
  name?: string | null;
} | null;

export const SUBMITTER_NAME_MAX_LENGTH = 24;

export type SubmitterNameDisplay = {
  text: string;
  title?: string;
};

function guestLabel(userId?: string | null): string {
  if (!userId) {
    return 'Guest';
  }
  const suffix = userId.length <= 4 ? userId : userId.slice(-4);
  return `Guest · ${suffix}`;
}

function truncateName(name: string, maxLength: number): SubmitterNameDisplay {
  if (name.length <= maxLength) {
    return { text: name };
  }
  return {
    text: `${name.slice(0, maxLength - 1)}…`,
    title: name,
  };
}

/** Admin-only label for the fan who submitted. Never returns a blank string. */
export function displaySubmitterName(
  user?: SubmitterUser,
  fallbackUserId?: string | null,
  options?: { truncate?: boolean },
): SubmitterNameDisplay {
  const trimmed = user?.name?.trim() ?? '';
  if (!trimmed) {
    return { text: guestLabel(user?.id ?? fallbackUserId) };
  }
  if (options?.truncate === false) {
    return { text: trimmed, title: trimmed };
  }
  return truncateName(trimmed, SUBMITTER_NAME_MAX_LENGTH);
}
